import React, { useState } from "react";

import BookActivityClub from "../../molecules/book-activity-club/bookActivityClub";
import ContentRotatorElement from "../../molecules/content-rotator-element/contentRotatorElement";
import ClubVotes from "../club-votes/clubVotes";
import { ReferenciaTabsContenido } from "../../../interfaces/ReferenciaTabsContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./clubActivity.scss";

interface ClubActivityProps extends ReferenciaTabsContenido {
  category: string;
}

const ClubActivity = (props: ClubActivityProps) => {
  const { referenciaContenido, category } = props;

  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderItems = referenciaContenido
    .filter((el) => el.autoresArticulo)
    .sort((a, b) => a.autoresArticulo[0] - b.autoresArticulo[0]);

  const handleSlide = (newSlide: number) => {
    if (newSlide >= 0 && newSlide < sliderItems.length)
      setCurrentSlide(newSlide);
  };

  const renderActivity = (tipoComponente: string) => {
    switch (tipoComponente) {
      case "LibroClub":
        return (
          <BookActivityClub
            {...sliderItems[currentSlide]}
            gtmClass={`${normalizeTwoWords(category)}${normalizeTwoWords(
              referenciaContenido[0].tituloGeneral
            )}`}
          />
        );
      case "RotadorPrincipal":
        return (
          <ContentRotatorElement
            {...sliderItems[currentSlide]}
            gtmClass={`${normalizeTwoWords(category)}${normalizeTwoWords(
              referenciaContenido[0].tituloGeneral
            )}`}
          />
        );
      case "VotacionLibro":
        return (
          <ClubVotes
            {...sliderItems[currentSlide]}
            gtmClass={`${normalizeTwoWords(category)}${normalizeTwoWords(
              referenciaContenido[0].tituloGeneral
            )}`}
          />
        );
    }
  };

  return (
    <section className="o-club-activity">
      <div className="o-club-activity__title-section">
        <h2 className="o-club-activity__title-section__title">
          {referenciaContenido[0].tituloGeneral}
        </h2>
        <div className="o-club-activity__title-section__right">
          <i
            className={`${
              currentSlide > 0 ? "icon" : "icon icon-disabled"
            } icon-chevron-left1 hide-on-desktop`}
            onClick={() => handleSlide(currentSlide - 1)}
          />
          <p className="o-club-activity__title-section__right__date">
            {
              referenciaContenido[0].descripcion.json.content[0].content[0]
                .value
            }
          </p>
          <i
            className={`${
              currentSlide > 0 ? "icon" : "icon icon-disabled"
            } icon-chevron-left1 hide-on-mobile`}
            onClick={() => handleSlide(currentSlide - 1)}
          />
          <i
            className={`${
              currentSlide === sliderItems.length - 1
                ? "icon icon-disabled"
                : "icon"
            } 
              icon-chevron-right1`}
            onClick={() => handleSlide(currentSlide + 1)}
          />
        </div>
      </div>
      <div className="o-club-activity__content">
        {renderActivity(sliderItems[currentSlide].tipoComponente)}
      </div>
    </section>
  );
};

export default ClubActivity;
